import { call, put } from "redux-saga/effects";
import { apiGeneral, notify } from "services";
import { ICreateRequest } from "interfaces/create-duck";
import { requestErrorHandler } from "utils";
import { CreateValePedagioTaxaActions } from "store/ducks/settings/vale-pedagio-taxas";

export function* createValePedagioTaxaRequest(action: any) {
  try {
    const { postData, onSuccess } = action as ICreateRequest;

    yield call(apiGeneral.post, `/vale-pedagio-taxas`, postData);

    yield put(CreateValePedagioTaxaActions.success());
    notify("success", "Taxa do Vale Pedágio criada com sucesso");
    if (onSuccess) onSuccess();
  } catch (error) {
    const { errorMessage } = requestErrorHandler(error);
    notify("error", errorMessage);
    yield put(CreateValePedagioTaxaActions.failure(errorMessage));
  }
}